import { render, staticRenderFns } from "./ConfirmRegisterEmail.vue?vue&type=template&id=7aff92de"
import script from "./ConfirmRegisterEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmRegisterEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports